module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA3XAAAN1wFCKJt4AAAAB3RJTUUH4QsHDAsK8fCingAAANJJREFUSMft1kFKw0AUBuDPGArWQ+QCWsEL6Cor6yUyN1D0NLmArqTbYF23FVQ8Qc4gQrvRRRPJxl2S1fzwYIaB98GsfvZJcY9XbPHT02yxaXanOthLj8h/s0Sa4hYXWZYpy9Lb05c+c3Z9rCgKdV1f4uag+cbzqqp6x9rM5lN5nsMmwQkGw+Bj8f1nJ5gYL5PEyIlgBCMYwQhGMIJ7cDeit0vw2baroTKbT9vje4IHCCF0H3rL6dWREEJ7fWyL8HKEIvyMw277vsN6gKq/anan8AvqXoDGZc7+kwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/territorio_provincias.png
// module id = pc6R
// module chunks = 0